<template>
  <div class="sp-template">
    <div class="h-title">公告&消息列表</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" size="small">
          <el-form-item label="优先级别">
            <el-select v-model="conditions.level" clearable placeholder="请选择优先级别">
              <el-option key="1" label="紧急" value="1"></el-option>
              <el-option key="2" label="一般" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker v-model="conditions.startTime" type="date" placeholder="请选择开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model="conditions.endTime" type="date" placeholder="请选择结束日期">
            </el-date-picker>
          </el-form-item>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(71102)" type="primary" size="small" @click="query()">搜 索</el-button>
            <el-button v-if="in_configs(71102)" size="small" @click="reset()">清 空</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.type" @tab-click="query">
          <el-tab-pane label="公告" name="NOTICE"></el-tab-pane>
          <el-tab-pane label="消息" name="MESSAGE"></el-tab-pane>
          <el-tab-pane label="更新报价" name="QUOTATION"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button v-if="in_configs(71101)" size="small" @click="dialogFormVisible = true">发布</el-button>
        </div>
      </div>
      <el-table :data="noticeData" stripe border style="width: 100%">
        <el-table-column prop="type" label="类型" width="80" :formatter="formatType"></el-table-column>
        <el-table-column prop="level" label="优先级别" width="100"></el-table-column>
        <el-table-column label="标题" width="200">
          <template slot-scope="scope">
            <p class="long-item">{{scope.row.title}}</p>
          </template>
        </el-table-column>
        <el-table-column label="内容">
          <template slot-scope="scope">
            <div class="quill-content ql-editor" v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="发布日期" width="200"></el-table-column>
        <el-table-column label="查看" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="in_configs(71103)" @click="review(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="parseInt(total)">
      </el-pagination>
      <!-- 弹窗 -->
      <el-dialog title="发布公告/消息" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="resetForm('form')" class="bulletin-dialog" width="800px">
        <el-form :model="form" entype="multipart/form-data" label-width="120px" status-icon label-position="left" :rules="rule" ref="form">
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" size="small" placeholder="请输入公告(或消息)标题"></el-input>
          </el-form-item>
          <el-form-item label="优先级别">
            <el-tooltip class="item" effect="dark" content="指的是这条公告(或消息)非必须查看" placement="top-start">
              <el-radio v-model="form.level" label="2">一般</el-radio>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="指的是这条公告(或消息)要求用户必须查看" placement="top-start">
              <el-radio v-model="form.level" label="1">紧急</el-radio>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-radio v-model="form.type" label="NOTICE" @click.native="removeFiles()">公告</el-radio>
            <el-radio v-model="form.type" label="MESSAGE" @click.native="removeFiles()">消息</el-radio>
            <el-tooltip class="item" effect="dark" content="针对客户类型更新报价" placement="top-start">
              <el-radio v-model="form.type" label="QUOTATION">更新报价</el-radio>
            </el-tooltip>
          </el-form-item>
          <el-form-item v-if="form.type === 'QUOTATION'">
            <el-button @click.native.prevent="addRow(form.files)" type="primary" plain size="small">
              添加一行
            </el-button>
            <el-table :data="form.files" border style="width: 100%" class="add-file__table">
              <el-table-column label="客户类型">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.customerType" clearable placeholder="请选择客户类型" size="small">
                    <el-option v-for="(customerType, index) in customerTypeList" :key="index" :label="customerType.name" :value="customerType.value"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="excel 文件">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.excel" type="file" size="small" multiple="multiple" name="excel" accept=".xls,.xlsx" @change="getFile(scope.$index,scope.row.customerType)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="deleteRow(scope.$index, form.files)" type="text" size="small">
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <div class="edit_container">
              <quill-editor v-model="form.content" ref="myQuillEditor" class="editer" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)">
              </quill-editor>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="resetForm('form')">取 消</el-button>
          <el-button size="small" type="primary" @click="createdNotice('form')">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="title" :visible.sync="dialogNoticeVisible" width="500px">
        <div class="dialog-content">
          <span class="title">标题：</span>
          <span class="content">{{checkNotice.title}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">优先级：</span>
          <span class="content">{{checkNotice.level}}</span>
        </div>
        <div class="dialog-content" v-if="checkNotice.quotationNoticeValues && checkNotice.quotationNoticeValues.length > 0">
        <span class="title">最新报价：</span>
        <span class="content">
          <a 
            class="content-price__download"
            :href="item.quotationUrl" 
            v-for="(item, index) in checkNotice.quotationNoticeValues" 
            :key="index"
            title="点击下载报价单">
            {{customerTypeMap[item.customerType]}}
          </a>
        </span>
      </div>
        <div class="dialog-content">
          <span class="title">发布时间：</span>
          <span class="content">{{checkNotice.createDate}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">内容：</span>
          <span class="content text-content ql-editor" v-html="checkNotice.content"></span>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "公告",
      conditions: {
        type: "NOTICE",
        level: "",
        startTime: "",
        endTime: ""
      },
      checkNotice: "",
      noticeData: [],
      form: {
        title: "",
        type: "NOTICE",
        level: "2",
        files: [{ customerType: "", excel: "" }],
        content: ""
      },
      quotationFiles: [],
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"]
          ],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },
      rule: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        content: [
          { required: true, message: "请输入公告(或信息)内容", trigger: "blur" }
        ]
      },
      currentPage: 1, // 当前是第几页
      pageSize: 10, // 每页显示条目个数
      total: 0, // 总条目数
      isUpload: "no",
      customerTypeMap: {},
      customerTypeList: [
        // { name: "普通客户", value: "NORMAL" },
        // { name: "线上自营", value: "ONLINE_SELF_EMPLOYED" },
        // { name: "线下自营", value: "OFFLINE_SELF_EMPLOYED" },
        // { name: "线上代理", value: "ONLINE_AGENCY" },
        // { name: "线下代理", value: "OFFLINE_AGENCY" }
      ],
      dialogFormVisible: false,
      dialogNoticeVisible: false
    };
  },
  filters: {
    filterCustomerType(val) {
      switch (val) {
        case "NORMAL":
          return "普通客户";
          break;
        case "ONLINE_SELF_EMPLOYED":
          return "线上自营";
          break;
        case "OFFLINE_SELF_EMPLOYED":
          return "线下自营";
          break;
        case "ONLINE_AGENCY":
          return "线上代理";
          break;
        case "OFFLINE_AGENCY":
          return "线下代理";
          break;
      }
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  created() {
    setTimeout(() => {
      this.query();
      this.getCustomerType()
    }, 1000);
  },
  methods: {
    // 获取客户类型
    getCustomerType() {
      this.$request1.get(
        '/customer/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
          this.customerTypeList.forEach(item => {
            this.customerTypeMap[item.value] = item.name
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    formatType(val) {
      switch (val.type) {
        case "NOTICE":
          return "公告";
          break;
        case "MESSAGE":
          return "消息";
          break;
        case "QUOTATION":
          return "报价单";
          break;
      }
    },
    reset() {
      this.conditions = {
        type: "NOTICE",
        level: "",
        startTime: "",
        endTime: ""
      }
      this.query()
    },
    query() {
      if (this.conditions.level == "") {
        this.conditions.level = 0;
      }
      this.$request1({
        method: 'post',
        url: '/notice/query',
        data: {
          type: this.conditions.type,
          level: this.conditions.level,
          startTime: this.conditions.startTime,
          endTime: this.conditions.endTime,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      })
        .then(response => {
          this.total = response.data.total;
          this.noticeData = response.data.data;
          if (this.conditions.level == 0) {
            this.conditions.level = "";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getFile(index) {
      this.$set(this.quotationFiles, index, event.target.files[0]);
    },
    createdNotice(formName) {
      let _this = this;
      this.$refs[formName].validate(valid => {
        if (_this.form.title.length > 60) {
          this.$message.error("填写的标题太长!");
          return;
        }
        if (_this.form.content.length > 1024 * 1024 * 2) {
          this.$message.error("填写的内容不能超过2MB!");
          return;
        }

        if (valid) {
          var formData = new FormData();
          for (var key in _this.form) {
            formData.append(key, _this.form[key]);
          }

          this.quotationFiles.forEach((item, index) => {
            this.form.files.forEach((file, i) => {
              if (index == i && file.excel.indexOf(item.name) != -1) {
                formData.append(file.customerType, item);
              }
            });
          });
          this.$request1({
            method: 'post',
            url: '/notice/create',
            data: formData
          })
            .then(response => {
              if (response.data.success) {
                this.$refs[formName].resetFields();
                this.emptyForm();
                this.dialogFormVisible = false;
                this.query();
                this.$message({
                  message: "发布成功",
                  type: "success",
                  center: true,
                  duration: 1500
                });
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    review(index, row) {
      this.title = this.formatType(row)
      this.dialogNoticeVisible = true;
      this.checkNotice = row;
    },
    // 选择客户类型上传文件 添加一行
    addRow(data) {
      if (data.length >= 5) {
        this.$notify({
          title: "警告",
          message: "最多只能上传5份报价（每类客户各一份）！",
          type: "warning"
        });
        return;
      }
      data.push({});
    },
    // 选择客户类型上传文件 删除一行
    deleteRow(index, data) {
      data.splice(index, 1);
    },
    // 点否的时候清空针对客户的文件列表
    removeFiles() {
      this.form.files = [{ customerType: "", excel: "" }];
    },
    emptyForm() {
      this.form.title = "";
      this.form.type = "NOTICE";
      this.form.level = "2";
      this.form.content = "";
      this.form.files = [{ customerType: "", excel: "" }];
      this.isUpload = "no";
      this.dialogFormVisible = false;
    },
    resetForm(formName) {
      this.$refs[formName].clearValidate();
      this.emptyForm();
    },
    onEditorBlur(editor) {
      console.log("editor blur!", editor);
    },
    onEditorFocus(editor) {
      console.log("editor focus!", editor);
    },
    onEditorReady(editor) {
      console.log("editor ready!", editor);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    }
  }
};
</script>

<style lang="scss" scoped>
.long-item,
.quill-content :first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.quill-content :not(:first-child) {
  display: none;
}
.upload-content {
  display: flex;
  .upload-content__file {
    display: flex;
    .file {
      margin: 0 20px;
    }
  }
}

.content-price__download{
  margin-right: 15px;
  color: rgb(64, 158, 255);
  &:hover{
    text-decoration: underline;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/system/bulletin.vue